if (!customElements.get('product-bundles')) {
  class ProductBundles extends HTMLElement {
    constructor() {
      super();

      this.productId = this.dataset.productId;

      this.productVariants = JSON.parse(
        this.querySelector(`#product-variants-data-${this.productId}`).textContent
      );

      this.productOptions = JSON.parse(
        this.querySelector(`#product-options-data-${this.productId}`).textContent
      );

      this.currentSelectedVariants = {};
      this.selectedOptionValues = {};

      this.optionIndexMap = this.createOptionIndexMap();

      this.bundleOptions = this.querySelectorAll('input[name="bundle_size"]');
      this.bundleUnitSelectors = this.querySelectorAll('.m-bundle-unit');

      this.bundledVariantPickers = [];


      this.discountedPriceDisplay =  this.querySelector('.m-final-price');

      this.savingBadgeDisplay =  this.querySelector('.m-saving-badge');

      this.originalPriceDisplay = this.querySelector('.m-original-price');
      this.addToCartButton = this.querySelector('#ProductSubmitButton-bundle-' + this.productId);

      this.boundHandleBundledVariantChange = this.handleBundledVariantChange.bind(this);
    this.debouncedHandleBundledVariantChange = this.debounce(this.handleBundledVariantChange.bind(this), 100);
    }

    connectedCallback() {
      this.bundleOptions.forEach(radio => {
        radio.addEventListener('change', () => this.updateBundleDisplay());
      });

      this.addToCartButton?.addEventListener('click', (e) =>
        this.handleAddToCart(e)
      );

      this.initializeBundledVariantPickers();


      this.bundledVariantPickers.forEach(picker => {
        picker.removeEventListener('change', this.boundHandleBundledVariantChange); // Remove old listener
        picker.addEventListener('change', this.debouncedHandleBundledVariantChange); // Add debounced listener
      });

      this.initializeDefaultSelections();

      if (
        !document.documentElement.dataset.bundleActiveProductId ||
        document.documentElement.dataset.bundleActiveProductId === this.productId
      ) {
        document.documentElement.dataset.bundleActiveProductId = this.productId;
      }

      this.updateBundleDisplay();
    }

    disconnectedCallback() {
      if (
        document.documentElement.dataset.bundleActiveProductId === this.productId
      ) {
        delete document.documentElement.dataset.bundleActiveProductId;
      }
    }

    /* -------------------------
       INIT PICKERS
    --------------------------*/
initializeBundledVariantPickers() {
  this.bundledVariantPickers.forEach(picker => {
    picker.removeEventListener('change', this.boundHandleBundledVariantChange);
  });

  this.bundledVariantPickers = [];

  const pickers = this.querySelectorAll('variant-picker[data-is-bundled-unit="true"]');

  pickers.forEach(picker => {
    this.bundledVariantPickers.push(picker);

    const unitIndex = Number(picker.dataset.unitIndex);

    picker.addEventListener('change', this.boundHandleBundledVariantChange);

    // attach unit index to all fields
    picker.querySelectorAll('input, select').forEach(el => {
      el.dataset.unitIndex = unitIndex;
    });

    // restore safely
    if (this.selectedOptionValues[unitIndex]) {
      this.restorePickerSelection(picker, this.selectedOptionValues[unitIndex]);
    }
  });
}


initializeDefaultSelections() {
  this.bundledVariantPickers.forEach(picker => {
    const unitIndex = Number(picker.dataset.unitIndex);
    const disableDefault = picker.dataset.disableDefaultSelection === 'true'; // Check the new dataset attribute

    let selectedValues = {};

    if (disableDefault) {
      // If default selection is disabled, ensure no values are pre-selected
      selectedValues = {};
    } else {
      // Otherwise, proceed with reading default selections from the DOM
      const wrappers = picker.querySelectorAll(
        '[data-option-name]'
      );

      wrappers.forEach(wrapper => {
        const optionName =
          wrapper.dataset.optionName?.toLowerCase();

        if (!optionName) return;

        const checked = wrapper.querySelector(
          'input[type="radio"]:checked'
        );

        const select = wrapper.querySelector('select');

        if (checked) {
          selectedValues[optionName] = checked.value;
        } else if (select) {
          selectedValues[optionName] =
            select.selectedOptions?.[0]?.value;
        }
      });
    }
    this.selectedOptionValues[unitIndex] = selectedValues;
  });

  this.updatePriceDisplay();
}

    /* -------------------------
       CHANGE HANDLER
    --------------------------*/
handleBundledVariantChange(event) {

  const input = event.target;

  const picker =
    input.closest('variant-picker[data-is-bundled-unit="true"]');

  if (!picker) return;

  // FULLY recalculate picker state
  this.updateSelectedOptionsFromPicker(picker);

  // Recalculate prices
  this.updatePriceDisplay();
}
    /* -------------------------
       RESTORE STATE
    --------------------------*/
restorePickerSelection(pickerElement, selectedOptions) {
  const wrappers = pickerElement.querySelectorAll('[data-option-name]');

  wrappers.forEach(wrapper => {
    const optionName = wrapper.dataset.optionName?.toLowerCase();
    const selectedValue = selectedOptions[optionName];

    if (!optionName || !selectedValue) return;

    wrapper.querySelectorAll('input[type="radio"], select').forEach(field => {
      if (field.type === 'radio') {
        field.checked = (field.value === selectedValue);
      }

      if (field.tagName === 'SELECT') {
        field.value = selectedValue;
      }
    });
  });

  this.updateUnitLabels(pickerElement, selectedOptions);
}
    /* -------------------------
       COLLECT VALUES
    --------------------------*/
updateSelectedOptionsFromPicker(picker) {
  const unitIndex = Number(picker.dataset.unitIndex);
  const selectedValues = {};

  const wrappers = picker.querySelectorAll('[data-option-name]');

  wrappers.forEach(wrapper => {
    const optionName = wrapper.dataset.optionName?.toLowerCase();
    if (!optionName) return;

    const checked = wrapper.querySelector('input[type="radio"]:checked');
    const select = wrapper.querySelector('select');

    if (checked) {
      selectedValues[optionName] = checked.value;
    } else if (select) {
      const opt = select.selectedOptions?.[0];
      if (opt) selectedValues[optionName] = opt.value;
    }
  });
  this.selectedOptionValues[unitIndex] = selectedValues;

  this.updateUnitLabels(picker, selectedValues);
}
    /* -------------------------
       LABEL UI
    --------------------------*/
updateUnitLabels(pickerElement, selectedOptions) {
  const wrappers = pickerElement.querySelectorAll('[data-option-name]');

  wrappers.forEach(wrapper => {
    const optionName = wrapper.dataset.optionName?.toLowerCase();
    if (!optionName) return;

    const label = wrapper.querySelector('.option-label--selected');
    if (!label) return;

    const value = selectedOptions[optionName];

    label.textContent = value || '';
  });
}
    /* -------------------------
       BUNDLE DISPLAY
    --------------------------*/
    updateBundleDisplay() {
      const selectedBundleSizeInput = this.querySelector('input[name="bundle_size"]:checked');
      const selectedBundleSize = selectedBundleSizeInput ? Number(selectedBundleSizeInput.value) : 0;

      this.bundleUnitSelectors.forEach(unit => {
        const index = Number(unit.dataset.unitIndex);
        unit.style.display = index <= selectedBundleSize ? 'block' : 'none';
      });

      // Only set active product ID if a bundle size is actually selected
      if (selectedBundleSize > 0) {
        document.documentElement.dataset.bundleActiveProductId = this.productId;
      } else {
        delete document.documentElement.dataset.bundleActiveProductId;
      }

      this.updatePriceDisplay();
    }

    /* -------------------------
       PRICE CALCULATION
    --------------------------*/
updatePriceDisplay() {
  const selectedBundleSizeInput = this.querySelector('input[name="bundle_size"]:checked');
  const selectedBundleSize = selectedBundleSizeInput ? Number(selectedBundleSizeInput.value) : 0;

  const discount = selectedBundleSizeInput ? parseFloat(selectedBundleSizeInput.dataset.discount) : 0;

  let totalPrice = 0;
  let allValid = true;

  this.currentSelectedVariants = {};

  // Get price labels
  const originalPriceLabel = this.querySelector('.m-original-price-label');
  const finalPriceLabel = this.querySelector('.m-final-price-label');

  if (selectedBundleSize === 0) {
    // No bundle size selected, clear displays and disable button
    this.originalPriceDisplay.textContent = '';
    this.discountedPriceDisplay.textContent = '';
    this.savingBadgeDisplay.style.display = 'none';
    this.savingBadgeDisplay.textContent = ''; // Clear content
    this.toggleAddToCartButton(false);
    // Hide price labels if no bundle is selected
    if (originalPriceLabel) originalPriceLabel.style.display = 'none';
    if (finalPriceLabel) finalPriceLabel.style.display = 'none';
    return;
  }

  for (let i = 1; i <= selectedBundleSize; i++) {
    const unitData = this.selectedOptionValues[i];

    // 🔴 HARD CHECK
    if (!unitData || Object.keys(unitData).length === 0) {
      allValid = false;
      break;
    }

    const variant = this.findVariant(unitData);

    if (!variant) {
      allValid = false;
      break;
    }

    totalPrice += Number(variant.price);
    this.currentSelectedVariants[i] = variant.id;
  }

  if (!allValid) {
    this.originalPriceDisplay.textContent = '';
    this.discountedPriceDisplay.textContent = '';
    this.savingBadgeDisplay.style.display = 'none';
    this.savingBadgeDisplay.textContent = ''; // Clear content
    this.toggleAddToCartButton(false);
    // Hide price labels
    if (originalPriceLabel) originalPriceLabel.style.display = 'none';
    if (finalPriceLabel) finalPriceLabel.style.display = 'none';
    return;
  }

  // Show price labels when a bundle is selected
  if (originalPriceLabel) originalPriceLabel.style.display = 'inline';
  if (finalPriceLabel) finalPriceLabel.style.display = 'inline';

  const discounted = totalPrice * (1 - discount); // Calculate actual discounted value
  const originalPriceFormatted = Shopify.formatMoney(totalPrice);
  const discountedPriceFormatted = Shopify.formatMoney(discounted);

  this.discountedPriceDisplay.textContent = discountedPriceFormatted; // Ensure final price is always displayed

  if (discount > 0) {
    this.originalPriceDisplay.textContent = originalPriceFormatted;
    const savingsPercentage = Math.round(discount * 100);
    this.savingBadgeDisplay.textContent = `Save ${savingsPercentage}%`;
    this.savingBadgeDisplay.style.display = 'inline-block';
  } else {
    this.originalPriceDisplay.textContent = ''; // Clear original price if no discount
    this.savingBadgeDisplay.style.display = 'none';
    this.savingBadgeDisplay.textContent = '';
  }

  this.toggleAddToCartButton(true);
}    /* -------------------------
       BUTTON STATE
    --------------------------*/
    toggleAddToCartButton(valid) {
      if (valid) {
        this.addToCartButton?.removeAttribute('disabled');
      } else {
        this.addToCartButton?.setAttribute('disabled', 'disabled');
      }
    }

    /* -------------------------
       VARIANT MATCH
    --------------------------*/
findVariant(options) {

  return this.productVariants.find(variant => {

    const variantOptions = [
      variant.option1,
      variant.option2,
      variant.option3
    ]
      .filter(Boolean)
      .map(v => v.toLowerCase().trim());

    const selectedValues = Object.values(options)
      .map(v => v.toLowerCase().trim());

    return selectedValues.every(value =>
      variantOptions.includes(value)
    );

  });

}
    /* -------------------------
       ADD TO CART
    --------------------------*/
    handleAddToCart(event) {
      event.preventDefault();

      this.addToCartButton.setAttribute('disabled', 'disabled');

      const selectedBundleSize = Number(
        this.querySelector('input[name="bundle_size"]:checked')?.value || 0
      );

      const itemCounts = {};

      for (let i = 1; i <= selectedBundleSize; i++) {
        const id = this.currentSelectedVariants[i];

        if (id) {
          itemCounts[id] = (itemCounts[id] || 0) + 1;
        }
      }

      const items = Object.entries(itemCounts).map(([id, quantity]) => ({
        id: Number(id),
        quantity: quantity,
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(() => (window.location.href = '/cart'))
        .catch(err => {
          console.error(err);
          this.addToCartButton.removeAttribute('disabled');
        });
    }

    /* -------------------------
       OPTION MAP
    --------------------------*/
    createOptionIndexMap() {
      const map = {};

      this.productOptions.forEach((opt, i) => {
        map[opt.toLowerCase()] = `option${i + 1}`;
      });

      return map;
    }

    debounce(func, delay) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
      };
    }
  }

  customElements.define('product-bundles', ProductBundles);
}